(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('alumno-uady-matriculado', {
            parent: 'entity',
            url: '/alumno-uady-matriculado',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AlumnoUadyMatriculados'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/alumno-uady-matriculado/alumno-uady-matriculados.html',
                    controller: 'AlumnoUadyMatriculadoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('alumno-uady-matriculado-detail', {
            parent: 'alumno-uady-matriculado',
            url: '/alumno-uady-matriculado/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'AlumnoUadyMatriculado'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/alumno-uady-matriculado/alumno-uady-matriculado-detail.html',
                    controller: 'AlumnoUadyMatriculadoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'AlumnoUadyMatriculado', function($stateParams, AlumnoUadyMatriculado) {
                    return AlumnoUadyMatriculado.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'alumno-uady-matriculado',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('alumno-uady-matriculado-detail.edit', {
            parent: 'alumno-uady-matriculado-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alumno-uady-matriculado/alumno-uady-matriculado-dialog.html',
                    controller: 'AlumnoUadyMatriculadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AlumnoUadyMatriculado', function(AlumnoUadyMatriculado) {
                            return AlumnoUadyMatriculado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('alumno-uady-matriculado.new', {
            parent: 'alumno-uady-matriculado',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alumno-uady-matriculado/alumno-uady-matriculado-dialog.html',
                    controller: 'AlumnoUadyMatriculadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('alumno-uady-matriculado', null, { reload: 'alumno-uady-matriculado' });
                }, function() {
                    $state.go('alumno-uady-matriculado');
                });
            }]
        })
        .state('alumno-uady-matriculado.edit', {
            parent: 'alumno-uady-matriculado',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alumno-uady-matriculado/alumno-uady-matriculado-dialog.html',
                    controller: 'AlumnoUadyMatriculadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AlumnoUadyMatriculado', function(AlumnoUadyMatriculado) {
                            return AlumnoUadyMatriculado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('alumno-uady-matriculado', null, { reload: 'alumno-uady-matriculado' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('alumno-uady-matriculado.delete', {
            parent: 'alumno-uady-matriculado',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alumno-uady-matriculado/alumno-uady-matriculado-delete-dialog.html',
                    controller: 'AlumnoUadyMatriculadoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AlumnoUadyMatriculado', function(AlumnoUadyMatriculado) {
                            return AlumnoUadyMatriculado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('alumno-uady-matriculado', null, { reload: 'alumno-uady-matriculado' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
